var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('message-form',{attrs:{"message-type":"new","predefined-to":_vm.predefinedTo},on:{"route-change":function (routeName) { return _vm.$emit('route-change', routeName); }}})}
var staticRenderFns = []

export { render, staticRenderFns }